<template>
  <div class="content">
    <VozIntroSection />
    <VozEcosystemAndCompanyBrand />
    <VozExpressionProfileSection />
    <VozGuidelineFamilySection />
    <VozGuidelineStrikingSection />
    <VozGuidelineAdaptableSection />
    <VozGuidelineTransparentSection />     
  </div>
</template>

<script lang="ts">
import VozGuidelineTransparentSection from "@/components/VerbalIdentityPage/sections/voz/VozGuidelineTransparentSection.vue"
import VozGuidelineAdaptableSection from '@/components/VerbalIdentityPage/sections/voz/VozGuidelineAdaptableSection.vue';
import VozGuidelineStrikingSection from '@/components/VerbalIdentityPage/sections/voz/VozGuidelineStrikingSection.vue';
import VozGuidelineFamilySection from '@/components/VerbalIdentityPage/sections/voz/VozGuidelineFamilySection.vue';
import VozExpressionProfileSection from '@/components/VerbalIdentityPage/sections/voz/VozExpressionProfileSection.vue';
import VozEcosystemAndCompanyBrand from '@/components/VerbalIdentityPage/sections/voz/VozEcosystemAndCompanyBrand.vue';
import VozIntroSection from '@/components/VerbalIdentityPage/sections/voz/VozIntroSection.vue';
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {    
    VozIntroSection,
    VozEcosystemAndCompanyBrand,
    VozExpressionProfileSection,
    VozGuidelineFamilySection,
    VozGuidelineStrikingSection,
    VozGuidelineAdaptableSection,
    VozGuidelineTransparentSection
  }
})
export default class VozView extends Vue {}
</script>

<style lang="scss"></style>
